export default __webpack_public_path__ + "static/media/sendfast.00309245.jpg";